import React from "react";
import {
  Paper,
  Typography,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import SortIcon from "@material-ui/icons/Sort";
import ScheduleIcon from "@material-ui/icons/Schedule";
import ListAltIcon from "@material-ui/icons/ListAlt";
import { formatRelativeTime } from "../helpers/time";

const CadeteSidePanel = ({ cadetes, selectedCadeteId, onSelectCadete, sortMode, onSortChange }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleSelect = (cadeteId) => {
    if (!onSelectCadete) return;
    onSelectCadete((current) => (current === cadeteId ? null : cadeteId));
  };

  const handleOpenSort = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseSort = () => setAnchorEl(null);

  const handleSortOption = (mode) => {
    if (onSortChange) onSortChange(mode);
    handleCloseSort();
  };

  return (
    <Paper className="cadete-side-panel" elevation={1}>
      <div className="panel-header">
        <div className="panel-title">
          <Typography variant="h6">Cadetes</Typography>
          <Typography variant="caption" color="textSecondary">
            Orden: {sortMode === "mostOrders" ? "Más pedidos" : "Último tracking"}
          </Typography>
        </div>
        <IconButton size="small" onClick={handleOpenSort} className="sort-button">
          <SortIcon fontSize="small" />
        </IconButton>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseSort}>
          <MenuItem
            selected={sortMode === "lastTracking"}
            onClick={() => handleSortOption("lastTracking")}
          >
            <ListItemIcon>
              <ScheduleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Último tracking" />
          </MenuItem>
          <MenuItem
            selected={sortMode === "mostOrders"}
            onClick={() => handleSortOption("mostOrders")}
          >
            <ListItemIcon>
              <ListAltIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Más pedidos" />
          </MenuItem>
        </Menu>
      </div>
      <Divider />
      <div className="panel-list">
        {cadetes.length === 0 && (
          <Typography variant="body2" color="textSecondary" className="panel-empty">
            No hay cadetes con tracking para esta ciudad.
          </Typography>
        )}
        {cadetes.map((cadete) => {
          const isSelected = cadete.id === selectedCadeteId;
          return (
            <div
              className={`cadete-row ${isSelected ? "selected" : ""}`}
              key={cadete.id}
              onClick={() => handleSelect(cadete.id)}
            >
              <div className="cadete-info">
                <span className="color-dot" style={{ backgroundColor: cadete.color }} />
                <div>
                  <Typography variant="subtitle2">
                    {cadete.nombre} {cadete.apellido}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Pedidos: {cadete.pedidos?.length || 0}
                  </Typography>
                </div>
              </div>
              <Typography variant="caption" color="textSecondary">
                {formatRelativeTime(cadete.lastTrackingAt)}
              </Typography>
            </div>
          );
        })}
      </div>
    </Paper>
  );
};

export default CadeteSidePanel;
